<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div mat-dialog-title class="matDialogTitle">
    جزئیات
    <span (click)="close()">
        <mat-icon class="close">
            close
        </mat-icon>
    </span>
</div>

<form #form1="ngForm">
    <div mat-dialog-content class="matDialogContent">
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
                <label for="title" class='wh-label'> عنوان درخواست :
                    <input class='wh-input' name='title' [(ngModel)]='title' autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> زمینه همکاری :
                    <input class='wh-input' name='coop_title' [(ngModel)]='coop_title' autocomplete="off"
                        (click)="load_service(57,'')">
                    <input class='wh-input' name='coop' [(ngModel)]='coop' autocomplete="off" style="display: none;">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> نوع پروژه :
                    <input class='wh-input' name='project_title' [(ngModel)]='project_title' autocomplete="off"
                        (click)="load_service(58,'')">
                    <input class='wh-input' name='project' [(ngModel)]='project' autocomplete="off"
                        style="display: none;">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> متراژ تقریبی :
                    <input class='wh-input' name='meter' [(ngModel)]='meter' autocomplete="off">
                </label>
            </div>


            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> محل پروژه :
                    <input class='wh-input' name='place' [(ngModel)]='place' autocomplete="off">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> درخواست ملاقات حضوری :
                    <input class='wh-input' name='visit_title' [(ngModel)]='visit_title' autocomplete="off"
                        (click)="load_service(59,'')">
                    <input class='wh-input' name='visit' [(ngModel)]='visit' autocomplete="off" style="display: none;">
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> تاریخ :
                    <input class='wh-input' name='date1_visit' [(ngModel)]='date1_visit' autocomplete="off">
                </label>
            </div>
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe'>
                <label for="title" class='wh-label'> نفر ارجاع شده :
                    <input class='wh-input' name='recipient_title' [(ngModel)]='recipient_title' autocomplete="off"
                        (click)="load_service(24,1)">
                    <input class='wh-input' name='recipient' [(ngModel)]='recipient' autocomplete="off"
                        style="display: none;">
                </label>
            </div>
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe'>
                <label for="title" class='wh-label'> توضیحات :
                    <textarea class='wh-input' name='comment' [(ngModel)]='comment' autocomplete="off"
                        style="height:5rem">
                 </textarea>
                </label>
            </div>
            <!-- ***************************************************************************************************** -->
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe' *ngIf="type_task == 2">
                <span (click)="add(1)"><i class="fas fa-plus"></i></span>
            </div>
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe' *ngIf="type_task == 2">
                <mat-table [dataSource]="dataSource2" style='min-width:100%'
                    class='table-scroll mat_table_fa_without_scroll pe1'>

                    <ng-container matColumnDef="row">
                        <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                            <span>ردیف</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>{{ i  }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="title2">
                        <mat-header-cell *matHeaderCellDef style='max-width:250px'>
                            <span>عنوان</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style='max-width:250px'>{{ x.user_task_title }}
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="comment2">
                        <mat-header-cell *matHeaderCellDef>
                            <span>توضیحات</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index">{{ x.user_task_comment }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="creator">
                        <mat-header-cell *matHeaderCellDef>
                            <span>ارجاع دهنده</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index">{{ x.creator }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="recipient">
                        <mat-header-cell *matHeaderCellDef>
                            <span>ارجاع گیرنده</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index">{{ x.recipient }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="operation">
                        <mat-header-cell *matHeaderCellDef style="max-width:70px">
                            <span>عملیات</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let x;let i = index" style="max-width:70px">
                            <span (clicl)="add(2)"><i class="fas fa-desktop icon"></i></span>
                            <span (clicl)="delete()"><i class="far fa-trash-alt icon"
                                    style='margin:0px 4px;'></i></span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns2" color="primary"></mat-header-row>
                    <mat-row *matRowDef="let row;columns:displayedColumns2" (click)="mat_table_selectedRow = row"
                        (mouseenter)="mat_table_hoverRow = row"
                        [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,'mat_table_hover': row === mat_table_hoverRow}"
                        class="cursor"></mat-row>
                </mat-table>
            </div>
            <!-- ***************************************************************************************************** -->

        </div>
    </div>
    <div mat-dialog-actions class="matDialogActions">
        <div class='col-md-12 pe1'>
            <button class="btn_pe" (click)="save()">ذخیره</button>
        </div>
    </div>
</form>


<ngx-smart-modal #myModal identifier="myModal" class="pe">
    <form #form_myModal="ngForm">
        <div style='text-align:center;padding:12px !important'>
            <span *ngIf="type_new_task==1">جديد</span>
            <span *ngIf="type_new_task==2">ويرايش</span>
        </div>
        <div class="row">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
                <label for="title" class='wh-label'>
                    <span> عنوان : </span>
                    <input class='wh-input' name='title2' [(ngModel)]='title2' autocomplete="off" required>
                </label>
            </div>
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
                <label for="title" class='wh-label'>
                    <span> نفر ارجاع شده : </span>
                    <input class='wh-input' name='recipient2_title' [(ngModel)]='recipient2_title' autocomplete="off"
                        (click)="load_service(24,2)">
                    <input class='wh-input' name='recipient2' [(ngModel)]='recipient2' autocomplete="off"
                        [hidden]="true">
                </label>
            </div>
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe'>
                <label for="title" class='wh-label'>
                    <span> توضیحات : </span>
                    <input class='wh-input' name='comment2' [(ngModel)]='comment2' autocomplete="off">
                </label>
            </div>
        </div>
        <div class="row">
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'>
                <button class="btn_pe" *ngIf='type_new_task == 1' (click)="insert_new_task()"
                    [disabled]="!form_myModal.valid">ارسال و ذخيره</button>
                <button class="btn_pe" *ngIf='type_new_task == 2' (click)="update_new_task(2)"
                    [disabled]="!form_myModal.valid">ويرايش</button>
            </div>
        </div>
    </form>
</ngx-smart-modal>